import { render, staticRenderFns } from "./TfccLayout.vue?vue&type=template&id=651449bb"
import script from "./TfccLayout.vue?vue&type=script&lang=js"
export * from "./TfccLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports